import { useEffect, useState, AnimationEvent } from 'react';
import type { FC } from 'react';
import styled, { css } from 'styled-components';

import { LazyLottie } from '@/ui/Lottie';
import type { LottieComponentProps } from '@/ui/Lottie';

const AnimationStyled: FC<LottieComponentProps & { hidden?: boolean }> = styled(LazyLottie)`
  ${({ hidden }) =>
    hidden &&
    css`
      display: none;
    `};
`;

export type LottieAnimationProps = LottieComponentProps & {
  hideWhenStill?: boolean;
  isPlaying?: boolean;
  animationReady?: boolean;
  onPlayingUpdate?: (playing: boolean) => void;
};

export const Animation = ({
  hideWhenStill,
  onComplete,
  isPlaying,
  onPlayingUpdate,
  animationReady,
  ...props
}: LottieAnimationProps): JSX.Element => {
  const [hidden, setHidden] = useState(hideWhenStill);

  useEffect(() => {
    if (!animationReady) return;

    if (isPlaying) {
      setHidden(false);
    } else if (hideWhenStill) {
      setHidden(true);
    }
  }, [isPlaying, hideWhenStill, animationReady]);

  const handleComplete = (e: AnimationEvent<Element>) => {
    onComplete?.(e);
    onPlayingUpdate?.(false);
  };

  return <AnimationStyled {...props} hidden={hidden} onComplete={handleComplete} />;
};

export { useLottieAnimation } from './useLottieAnimation';
